var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxBicycle = function Svg18PxBicycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.75 14.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4.25 14.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6M7.761 6.57l-.074-.187a1 1 0 0 0-.93-.633H5.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.75 11.75-3.156-9H14a1.25 1.25 0 0 1 0 2.5M4.25 11.75l7.683-5.18"
  })));
};
export default Svg18PxBicycle;